import { render, staticRenderFns } from "./ConnectionsView.vue?vue&type=template&id=5c601c86"
import script from "./ConnectionsView.vue?vue&type=script&lang=js"
export * from "./ConnectionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports